import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { OVERVIEW_PAGE_CONTENT } from "../../Dashboard/constants"
import { getAssetPath } from "../../../utils/assets"

const StyledNav = styled.nav`
  img:first-child {
    width: 64px;
    margin-right: 1em;
  }
  img:last-child {
    display: none;
    @media (min-width: 768px) {
      display: inline-block;
    }
  }
`

function PulseCheckHeader({
  form, inflight, invalidInput, totalQuestionLength, onSubmit
}) {
  return (
    <div className="fixed-top">
      <StyledNav className="navbar navbar-light bg-white">
        <Link to="/pulse-check-dashboard">
          <img src={getAssetPath(OVERVIEW_PAGE_CONTENT.pulse_check.logoAssetName)} width={64} height={64} />
          <img src={getAssetPath("pulse-logo-text")} width={100} height={36} />
        </Link>
        <div>
          <Link className="btn btn-outline-main btn-sm mr-2" to="/pulse-check-dashboard">Cancel</Link>
          {inflight ? (
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
        ) : (
          <button
            className="btn btn-main btn-sm"
            disabled={totalQuestionLength !== Object.keys(form).length || inflight || invalidInput}
            type="submit"
            onClick={onSubmit}>
            Done
          </button>
        )}
        </div>
      </StyledNav>
      <div className="progress survey-progress">
        <div
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={0}
          aria-label="Pulse Check survey completion"
          style={{ width: `${totalQuestionLength ? (Object.keys(form).length / totalQuestionLength) * 100 : 0}%` }}
          className="progress-bar"
          role="progressbar" />
      </div>
    </div>
  )
}

export default PulseCheckHeader